import snakeCase from 'lodash/snakeCase';

import {
  errorCodes,
  parseErrorCode,
} from '../../../global/constants/error-messages';

export const sessionTimeoutUnits = Object.freeze({
  second: 'second',
  minute: 'minute',
  hour: 'hour',
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
});

export const defaultSessionTimeout = Object.freeze({
  amount: 90,
  unit: sessionTimeoutUnits.day,
});

const genericMessageInvalidationTypes = Object.freeze({
  authMethodOrMFAChange: 'authMethodOrMFAChange',
});

const nonGenericMessageInvalidationTypes = Object.freeze({
  sessionTimeout: 'sessionTimeout',
});

export const sessionInvalidationTypes = Object.freeze({
  ...genericMessageInvalidationTypes,
  ...nonGenericMessageInvalidationTypes,
});

export const sessionInvalidationErrorCodes = Object.freeze(
  Object.keys(sessionInvalidationTypes).reduce<Record<string, any>>(
    (acc, invalidationType) => {
      acc[invalidationType] = parseErrorCode(
        errorCodes[snakeCase(sessionInvalidationTypes[invalidationType])][0],
      );

      return acc;
    },
    {},
  ),
);

export const sessionInvalidationHTTPStatus = 401;

export const genericLokaliseKey = 'session_invalidation';

const allGenericMessageTypesMappedToTheGenericLokaliseKey = Object.freeze(
  Object.keys(genericMessageInvalidationTypes).reduce<Record<string, any>>(
    (acc, messageType) => {
      acc[messageType] = genericLokaliseKey;

      return acc;
    },
    {},
  ),
);

const allNonGenericMessageTypesMappedToTheirLokaliseKeys = Object.freeze(
  Object.keys(nonGenericMessageInvalidationTypes).reduce<Record<string, any>>(
    (acc, messageType) => {
      acc[messageType] = snakeCase(messageType);

      return acc;
    },
    {},
  ),
);

export const typesMappedToLokaliseKeys = Object.freeze({
  ...allGenericMessageTypesMappedToTheGenericLokaliseKey,
  ...allNonGenericMessageTypesMappedToTheirLokaliseKeys,
});
